import React, { useState } from 'react';


export function bindStateToCheckbox(state) {
	const [checked, setChecked] = state;
	return {
		checked,
		onChange: e => setChecked(e.target.checked)
	};
}

export function bindStateToRadio(state, value, comparator?) {
	const [currentValue, setValue] = state;
	return {
		value,
		checked: comparator ? comparator(currentValue, value) : currentValue === value,
		onChange: () => setValue(value)
	};
}

export function bindStateToText(state, cast?) {
	const [value, setValue] = state;
	return {
		value: value ?? '',
		onChange: e => {
			if (typeof cast === 'function') {
				setValue(cast(e.target.value));
			} else {
				setValue(e.target.value);
			}
		}
	};
}

export function valid(...state) {
	return state.every(s => {
		return typeof s[2] === 'function' ? s[2]() : true;
	});
}

export type ValidateState<T> = [T, React.Dispatch<T>, () => boolean];
export function useValidateState<T>(defaultValue: T, fn: (value: T) => boolean): ValidateState<T> {
	const [value, setValue] = useState<T>(defaultValue);
	return [value, setValue, () => fn(value)];
}
export function isNull(v) {
	return v === null;
}
export function has(obj, v) {
	return Object.values(obj).includes(v);
}
export function isValidDate(date: Date | null) {
	return date instanceof Date && !Number.isNaN(date.getTime());
}
export function isValidBirthday(date: Date) {
	return isValidDate(date) && date.getTime() < Date.now();
}

export function toHalfString(str: string) {
	return str.replace(/[Ａ-Ｚａ-ｚ０-９]/g, s => String.fromCharCode(s.charCodeAt(0) - 65248));
}export function assertUnreachable(_x: never): never {
	throw new Error("Didn't expect to get here")
}

export function hiraToKana(str: string) {
	return str.replace(/[\u3041-\u3096]/g, s => String.fromCharCode(s.charCodeAt(0) + 96))
}

export const toHalfWidth = (str: string) => {
	return str.replace(/[Ａ-Ｚａ-ｚ０-９！＂＃＄％＆＇（）＊＋，－．／：；＜＝＞？＠［＼］＾＿｀｛｜｝]/g, s => String.fromCharCode(s.charCodeAt(0) - 65248))
		.replace(/[！-～]/g, str => String.fromCharCode(str.charCodeAt(0) - 65248))
		.replace(/[‐－―]/g, "-")
		.replace(/[～〜]/g, "~")
		.replace(/　/g, " ")
}

export const toHalfWidthNumber = (str: string) => {
	return toHalfString(str).replace(/[^\d]/g, '')
}